import createModalModel from './lib/create_modal_model';

export default createModalModel({
  modelName: 'CustomReportingError',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/custom_reporting_error.js